import { categories, mainSiteUrl } from '@/mocks/categories';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-accent-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Extremely%20faint%20thin%20outline%20italian%20peninsula%20map%20silhouette%20texture%20on%20dark%20olive%20green%20background%2C%20minimalist%20cartography%20style%2C%20very%20subtle%20pattern%2C%20elegant%20geographic%20texture&width=1200&height=800&seq=itaobuy-footer-v2-map&orientation=landscape')`,
        }}
      ></div>

      <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-14">
          <div>
            <h3 className="font-heading text-2xl font-bold mb-2">Itaobuy Spreadsheet</h3>
            <span className="inline-block w-2 h-2 rounded-full bg-accent-400 ml-1"></span>
            <p className="text-white/50 text-sm mt-6 max-w-[360px] leading-relaxed">
              La guida italiana pi&ugrave; completa per trovare, analizzare e utilizzare
              Itaobuy Spreadsheet. Tutte le informazioni di cui hai bisogno in un unico posto.
            </p>

            <div className="mt-8">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-400 transition-all cursor-pointer whitespace-nowrap"
              >
                Visita itaobuy sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-white/80 mb-4">Navigazione</h4>
              <ul className="space-y-2.5">
                <li><a href="#guida" onClick={(e) => { e.preventDefault(); document.getElementById('guida')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">Guida</a></li>
                <li><a href="#sicurezza" onClick={(e) => { e.preventDefault(); document.getElementById('sicurezza')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">Sicurezza</a></li>
                <li><a href="#faq" onClick={(e) => { e.preventDefault(); document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">FAQ</a></li>
                <li><button onClick={() => navigate('/articolo-guida-itaobuy-spreadsheet')} className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">Blog</button></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white/80 mb-4">Categorie</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.id}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">
                      {cat.nameIt}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white/80 mb-4">Altre Categorie</h4>
              <ul className="space-y-2.5">
                {categories.slice(6, 12).map((cat) => (
                  <li key={cat.id}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">
                      {cat.nameIt}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white/80 mb-4">Risorse</h4>
              <ul className="space-y-2.5">
                <li><a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">itaobuy sheet</a></li>
                <li><a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">buy it now</a></li>
                {categories.slice(12).map((cat) => (
                  <li key={cat.id}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">
                      {cat.nameIt}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; 2026 Itaobuy Spreadsheet Italia. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-3">
            {['ri-twitter-x-line', 'ri-instagram-line', 'ri-pinterest-line', 'ri-telegram-line'].map((icon, i) => (
              <a
                key={i}
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/15 text-white/50 hover:text-white hover:border-white/30 transition-all cursor-pointer"
              >
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>
          <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/40 text-xs hover:text-white/60 transition-colors cursor-pointer">
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}